import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import type { DayPricingModalTabIds } from 'lumen/utils/constants/pricing-assistant-constants';

import styles from './sidebar.module.css';

export interface SidebarItem {
  id: DayPricingModalTabIds;
  label: string;
}

interface DayOverrideModalSidebarSignature {
  Args: {
    activeId: string;
    ariaLabel?: string;
    items: SidebarItem[];
    onSelect: (id: DayPricingModalTabIds) => void;
  };
}

const isActive = (activeId: string, id: string): boolean => activeId === id;

const DayOverrideModalSidebar = <template>
  <nav aria-label={{@ariaLabel}} class={{styles.sidebar}}>
    <ul class={{styles.list}}>
      {{#each @items as |item|}}
        <li>
          <button
            aria-current={{if (isActive @activeId item.id) "page"}}
            class="{{styles.item}}
              {{if (isActive @activeId item.id) styles.active}}"
            data-test-id="day-override-modal-sidebar-{{item.id}}"
            type="button"
            {{on "click" (fn @onSelect item.id)}}
          >
            {{item.label}}
          </button>
        </li>
      {{/each}}
    </ul>
  </nav>
</template> satisfies TOC<DayOverrideModalSidebarSignature>;

export default DayOverrideModalSidebar;
